import { makeRequest, CommonRequestOptions } from '../../makeRequest';

export type AddBulkUsersToTeamsOptions = CommonRequestOptions & {
   userIds: number[];
   teamIds: number[];
};

type AddBulkUsersByTeamsResult = {
   id: number;
   authorid: number;
   result: string;
   no_ops: { userid: number; teamid: number }[];
   executed: { userid: number; teamid: number }[];
   created_at: number;
};

export function addBulkUsersToTeams({
   userIds,
   teamIds,
   ...common
}: AddBulkUsersToTeamsOptions): Promise<AddBulkUsersByTeamsResult> {
   return makeRequest('post', 'users/manage/bulk/add-users-to-teams', {
      body: {
         users: userIds,
         teams: teamIds,
      },
      ...common,
   });
}
